export const COMPLIANCE_WEBSITES = [
  { id: 'site-1', name: 'Acme Store', domain: 'acmestore.com' },
  { id: 'site-2', name: 'Blog Portal', domain: 'blog.acmestore.com' },
]

export const COMPLIANCE_SUMMARY = {
  currentScore: 87,
  scoreChange: 12,
  totalScans: 24,
  violationsFound: 156,
  violationsFixed: 134,
  monitoringCadence: 'Weekly (every Monday at 6:00 AM UTC)',
  lastScanAt: '2026-06-10T06:00:00Z',
  reportGeneratedAt: '2026-06-12T14:30:00Z',
}

export const AUDIT_TRAIL_ENTRIES = [
  {
    id: 'audit-001',
    scanId: 'SCN-2026-0610-001',
    websiteId: 'site-1',
    websiteName: 'Acme Store',
    url: 'https://acmestore.com',
    scannedAt: '2026-06-10T06:00:00Z',
    scanType: 'Full Site Crawl',
    wcagLevel: 'WCAG 2.1 AA',
    before: {
      complianceScore: 82,
      totalViolations: 18,
      critical: 2,
      serious: 5,
      moderate: 7,
      minor: 4,
    },
    after: {
      complianceScore: 87,
      totalViolations: 11,
      critical: 0,
      serious: 3,
      moderate: 5,
      minor: 3,
    },
    autoFixesApplied: 7,
    status: 'completed',
    hash: 'a3f8c2e1b9d4f6a7',
  },
  {
    id: 'audit-002',
    scanId: 'SCN-2026-0603-001',
    websiteId: 'site-1',
    websiteName: 'Acme Store',
    url: 'https://acmestore.com/products',
    scannedAt: '2026-06-03T06:00:00Z',
    scanType: 'Scheduled Scan',
    wcagLevel: 'WCAG 2.1 AA',
    before: {
      complianceScore: 74,
      totalViolations: 26,
      critical: 4,
      serious: 8,
      moderate: 9,
      minor: 5,
    },
    after: {
      complianceScore: 82,
      totalViolations: 18,
      critical: 2,
      serious: 5,
      moderate: 7,
      minor: 4,
    },
    autoFixesApplied: 8,
    status: 'completed',
    hash: 'b7e2d9f4c1a8e3b6',
  },
  {
    id: 'audit-003',
    scanId: 'SCN-2026-0527-001',
    websiteId: 'site-1',
    websiteName: 'Acme Store',
    url: 'https://acmestore.com/checkout',
    scannedAt: '2026-05-27T06:00:00Z',
    scanType: 'Scheduled Scan',
    wcagLevel: 'WCAG 2.1 AA',
    before: {
      complianceScore: 68,
      totalViolations: 32,
      critical: 5,
      serious: 10,
      moderate: 11,
      minor: 6,
    },
    after: {
      complianceScore: 74,
      totalViolations: 26,
      critical: 4,
      serious: 8,
      moderate: 9,
      minor: 5,
    },
    autoFixesApplied: 6,
    status: 'completed',
    hash: 'c9a1f3e7d2b5c8f0',
  },
  {
    id: 'audit-004',
    scanId: 'SCN-2026-0520-002',
    websiteId: 'site-2',
    websiteName: 'Blog Portal',
    url: 'https://blog.acmestore.com',
    scannedAt: '2026-05-20T06:00:00Z',
    scanType: 'Full Site Crawl',
    wcagLevel: 'WCAG 2.1 AA',
    before: {
      complianceScore: 91,
      totalViolations: 8,
      critical: 0,
      serious: 2,
      moderate: 4,
      minor: 2,
    },
    after: {
      complianceScore: 94,
      totalViolations: 5,
      critical: 0,
      serious: 1,
      moderate: 3,
      minor: 1,
    },
    autoFixesApplied: 3,
    status: 'completed',
    hash: 'd4c6b8a2e9f1d7c3',
  },
]

export const REMEDIATION_ENTRIES = [
  {
    id: 'rem-042',
    issueNumber: 42,
    violationType: 'Missing alt text',
    rule: 'image-alt',
    impact: 'serious',
    page: '/products/widget-a',
    fullUrl: 'https://acmestore.com/products/widget-a',
    fixedAt: '2026-06-05T14:14:00Z',
    fixedBy: 'Auto-fix',
    changeDescription: 'Added descriptive alt text to product image',
    before: 'alt=""',
    after: 'alt="Widget A — ergonomic desk accessory, blue finish"',
    websiteName: 'Acme Store',
    scanId: 'SCN-2026-0603-001',
  },
  {
    id: 'rem-041',
    issueNumber: 41,
    violationType: 'Insufficient color contrast',
    rule: 'color-contrast',
    impact: 'serious',
    page: '/products',
    fullUrl: 'https://acmestore.com/products',
    fixedAt: '2026-06-05T13:58:00Z',
    fixedBy: 'Auto-fix',
    changeDescription: 'Updated button text color to meet 4.5:1 contrast ratio',
    before: 'color: #94a3b8 on #ffffff (2.8:1)',
    after: 'color: #475569 on #ffffff (7.2:1)',
    websiteName: 'Acme Store',
    scanId: 'SCN-2026-0603-001',
  },
  {
    id: 'rem-040',
    issueNumber: 40,
    violationType: 'Missing form label',
    rule: 'label',
    impact: 'critical',
    page: '/checkout',
    fullUrl: 'https://acmestore.com/checkout',
    fixedAt: '2026-06-03T09:22:00Z',
    fixedBy: 'Manual fix (Team)',
    changeDescription: 'Associated label element with email input field',
    before: '<input type="email" id="email" placeholder="Email">',
    after: '<label for="email">Email address</label><input type="email" id="email">',
    websiteName: 'Acme Store',
    scanId: 'SCN-2026-0603-001',
  },
  {
    id: 'rem-039',
    issueNumber: 39,
    violationType: 'Empty link',
    rule: 'link-name',
    impact: 'moderate',
    page: '/about',
    fullUrl: 'https://acmestore.com/about',
    fixedAt: '2026-05-28T11:05:00Z',
    fixedBy: 'Auto-fix',
    changeDescription: 'Added aria-label to social media icon link',
    before: '<a href="https://twitter.com/acme"><img src="twitter.svg"></a>',
    after: '<a href="https://twitter.com/acme" aria-label="Follow us on Twitter"><img src="twitter.svg" alt=""></a>',
    websiteName: 'Acme Store',
    scanId: 'SCN-2026-0527-001',
  },
  {
    id: 'rem-038',
    issueNumber: 38,
    violationType: 'Missing page title',
    rule: 'document-title',
    impact: 'serious',
    page: '/blog/accessibility-tips',
    fullUrl: 'https://blog.acmestore.com/blog/accessibility-tips',
    fixedAt: '2026-05-22T16:40:00Z',
    fixedBy: 'Auto-fix',
    changeDescription: 'Set descriptive document title',
    before: '<title>Blog</title>',
    after: '<title>Accessibility Tips for Small Business — Acme Blog</title>',
    websiteName: 'Blog Portal',
    scanId: 'SCN-2026-0520-002',
  },
  {
    id: 'rem-037',
    issueNumber: 37,
    violationType: 'Missing heading hierarchy',
    rule: 'heading-order',
    impact: 'moderate',
    page: '/faq',
    fullUrl: 'https://acmestore.com/faq',
    fixedAt: '2026-05-20T08:15:00Z',
    fixedBy: 'Manual fix (Team)',
    changeDescription: 'Corrected heading levels from h4 to h3 for proper hierarchy',
    before: '<h2>FAQ</h2><h4>Shipping</h4>',
    after: '<h2>FAQ</h2><h3>Shipping</h3>',
    websiteName: 'Acme Store',
    scanId: 'SCN-2026-0527-001',
  },
]

export const REPORT_SECTIONS = [
  {
    id: 'executive',
    title: 'Executive Summary',
    description: 'Current compliance posture and good-faith effort overview',
  },
  {
    id: 'score',
    title: 'Compliance Score & Trends',
    description: 'Score history with before/after comparisons across all scans',
  },
  {
    id: 'remediation',
    title: 'Remediation History',
    description: 'Chronological log of every violation fixed with timestamps',
  },
  {
    id: 'violations',
    title: 'Violations Found vs. Fixed',
    description: 'Breakdown by severity: critical, serious, moderate, minor',
  },
  {
    id: 'audit',
    title: 'Timestamped Audit Trail',
    description: 'Immutable scan records with cryptographic verification hashes',
  },
  {
    id: 'monitoring',
    title: 'Monitoring Cadence',
    description: 'Scheduled scan frequency and last/next scan dates',
  },
]
